import { render } from "./buttonGroup.vue?vue&type=template&id=348457a0&lang=pug"
import script from "./buttonGroup.vue?vue&type=script&lang=js"
export * from "./buttonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/buttonGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "348457a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('348457a0', __exports__)) {
    api.reload('348457a0', __exports__)
  }
  
  module.hot.accept("./buttonGroup.vue?vue&type=template&id=348457a0&lang=pug", () => {
    api.rerender('348457a0', render)
  })

}


export default __exports__